import clsx from 'clsx'
import { observer } from 'mobx-react'
import * as React from 'react'

import { Loader } from '@/component/atoms/Loader'
import type { StyleProps } from '@/types'

import S from './_OldButton.style'

type Props = {
  theme?: keyof typeof S.theme
  width?: React.CSSProperties['width']
  height?: React.CSSProperties['height']
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  loading?: boolean
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> &
  StyleProps

/**
 *
 * @deprecated
 */
const _OldButton = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      theme = 'default',
      children,
      height = 40,
      width,
      style,
      onClick,
      disabled,
      className,
      loading,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        style={{ width, height, ...style }}
        className={clsx(className, loading && 'loading')}
        css={[S.basic, S.theme[theme]]}
        onClick={loading || disabled ? undefined : onClick}
        disabled={disabled}
        {...props}
      >
        {loading ? (
          <Loader
            theme={theme === 'individual' || theme === 'individual-gray' ? 'primary' : 'white'}
            width={parseInt(String(height)) - 20}
          />
        ) : (
          children
        )}
      </button>
    )
  },
)

_OldButton.displayName = '_OldButton'

export default observer(_OldButton)
